export const APP_FORMAT_DATE='DD MMM YYYY'
export const APP_FORMAT_DATETIME='DD MMM YYYY H:mm'
export const dayInterval=48 * 3600 * 1000;
export const monthInterval=30 * 24 * 3600 * 1000;
export const graphColors={
    GREEN:'#04A759',
    RED:'#ED4B48'
}